/* Taze Gurme UI polish — pass 8: mobile sort bridge to Shopify native facets. */
(function () {
  var scheduled = false;

  function getSortSource(toggle) {
    var scope = toggle.closest('.shopify-section') || document;
    return scope.querySelector('sorting-filter-component[data-testid="sorting-filter-component-desktop"]') ||
      document.querySelector('sorting-filter-component[data-testid="sorting-filter-component-desktop"]');
  }

  function readSortOptions(source) {
    if (!source) return [];

    return Array.prototype.slice.call(source.querySelectorAll('input[name="sort_by"]')).map(function (input) {
      var label = input.getAttribute('data-option-name');
      if (!label) {
        var option = input.closest('.sorting-filter__option');
        var labelElement = option && option.querySelector('.sorting-filter__label');
        label = labelElement ? labelElement.textContent.trim() : input.value;
      }

      return {
        value: input.value,
        label: label,
        checked: input.checked
      };
    });
  }

  function getSortLabel(source) {
    if (!source) return 'Sırala';
    var label = source.querySelector('.facets__label');
    return label && label.textContent.trim() ? label.textContent.trim() : 'Sırala';
  }

  function triggerNativeSort(source, value) {
    if (!source) return;

    var inputs = Array.prototype.slice.call(source.querySelectorAll('input[name="sort_by"]'));
    var target = inputs.find(function (input) { return input.value === value; });
    if (!target) return;

    target.checked = true;
    target.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function buildSort(toggle, source, options, index) {
    var control = document.createElement('div');
    control.className = 'tg-mobile-sort';

    var visibleLabel = document.createElement('span');
    visibleLabel.className = 'tg-mobile-sort__label';
    visibleLabel.textContent = getSortLabel(source);
    visibleLabel.setAttribute('aria-hidden', 'true');

    var caret = document.createElement('span');
    caret.className = 'tg-mobile-sort__caret';
    caret.setAttribute('aria-hidden', 'true');

    var select = document.createElement('select');
    select.className = 'tg-mobile-sort__select';
    select.id = 'tg-mobile-sort-' + index;
    select.setAttribute('aria-label', getSortLabel(source));

    options.forEach(function (item) {
      var option = document.createElement('option');
      option.value = item.value;
      option.textContent = item.label;
      option.selected = item.checked;
      select.appendChild(option);
    });

    select.addEventListener('change', function () {
      triggerNativeSort(getSortSource(toggle), select.value);
    });

    control.appendChild(visibleLabel);
    control.appendChild(caret);
    control.appendChild(select);

    var mobileControls = toggle.querySelector('.facets-mobile-wrapper');
    if (mobileControls) {
      toggle.insertBefore(control, mobileControls);
    } else {
      toggle.appendChild(control);
    }

    toggle.dataset.tgMobileSort = 'true';
  }

  function syncSort(toggle, options) {
    var select = toggle.querySelector('.tg-mobile-sort__select');
    if (!select) return;
    var selected = options.filter(function (item) { return item.checked; })[0];
    if (selected && select.value !== selected.value) select.value = selected.value;
  }

  function enhanceMobileSort() {
    var toggles = Array.prototype.slice.call(document.querySelectorAll('.facets-toggle'));

    toggles.forEach(function (toggle, index) {
      var source = getSortSource(toggle);
      var options = readSortOptions(source);
      if (!options.length) return;

      if (toggle.querySelector('.tg-mobile-sort')) {
        syncSort(toggle, options);
        return;
      }

      buildSort(toggle, source, options, index);
    });
  }

  function scheduleEnhance() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      enhanceMobileSort();
    });
  }

  function init() {
    enhanceMobileSort();

    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        return mutation.addedNodes && mutation.addedNodes.length;
      });
      if (relevant) scheduleEnhance();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', scheduleEnhance);
})();
